<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Hotel information"/>
        <container-list-item padded>
            <div class="columns">
                <div class="column">
                    <b-field label="Hotel Name" label-position="inside">
                        <b-input v-model="hotel.title"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Location" label-position="inside">
                        <b-input v-model="hotel.location"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Phone" label-position="inside">
                        <b-input v-model="hotel.phone"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Website" label-position="inside">
                        <b-input v-model="hotel.website"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>
        <subheader-list-item icon="fa-calendar-check" title="Default check-in / check-out"/>
        <container-list-item padded>
            <div class="columns">
                <div class="column is-4">
                    <b-field label="Check-In Date" label-position="inside">
                        <b-input type="date" v-model="hotel.default_start_date"/>
                    </b-field>
                </div>
                <div class="column is-3">
                    <b-field label="Check-In Time" label-position="inside">
                        <b-input type="time" v-model="hotel.default_start_time"/>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Timezone" label-position="inside">
                        <b-autocomplete
                            :data="startTzResults"
                            field="title"
                            v-model="hotel.default_start_tz"
                            icon="search"
                            open-on-focus
                            placeholder="Search...">

                            <template slot="empty">No results.</template>
                        </b-autocomplete>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column is-4">
                    <b-field label="Check-Out Date" label-position="inside">
                        <b-input type="date" v-model="hotel.default_end_date"/>
                    </b-field>
                </div>
                <div class="column is-3">
                    <b-field label="Check-Out Time" label-position="inside">
                        <b-input type="time" v-model="hotel.default_end_time"/>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Timezone" label-position="inside">
                        <b-autocomplete
                            :data="endTzResults"
                            field="title"
                            v-model="hotel.default_end_tz"
                            icon="search"
                            open-on-focus
                            placeholder="Search...">

                            <template slot="empty">No results.</template>
                        </b-autocomplete>
                    </b-field>
                </div>
            </div>
        </container-list-item>
        <!-- The contact-person fields that used to live here are gone: hotel
             contacts are real records now, added from the Contacts tab of the
             hotel card. Notes stays -- it binds the generic trip_hotels.notes
             column, which predates the contact block and was only ever
             DISPLAYED inside it. -->
        <subheader-list-item icon="fa-sticky-note" title="Hotel notes"/>
        <container-list-item padded>
            <div class="columns">
                <div class="column">
                    <b-field label="Notes" label-position="inside">
                        <b-input type="textarea" v-model="hotel.notes"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";

    import moment from 'moment-timezone';

    import {client as http} from '@/http_client';

    export default {
        name: 'HotelForm',
        props: {
            hotel: {
                type: Object,
                required: true
            }
        },
        data: function() {
            return {
                zones: moment.tz.names()
            }
        },
        computed: {
            startTzResults() {
                if (this.hotel && this.hotel.default_start_tz) {
                    return this.zones.filter((option) => {
                        return option
                            .toString()
                            .toLowerCase()
                            .indexOf(this.hotel.default_start_tz.toLowerCase()) >= 0;
                    });
                } else {
                    return this.zones;
                }
            },
            endTzResults() {
                if (this.hotel && this.hotel.default_end_tz) {
                    return this.zones.filter((option) => {
                        return option
                            .toString()
                            .toLowerCase()
                            .indexOf(this.hotel.default_end_tz.toLowerCase()) >= 0;
                    });
                } else {
                    return this.zones;
                }
            }
        },
        watch: {
            // Default the timezone fields to the trip's timezone, but never
            // clobber a hotel that already has one (editing).
            'hotel.trip_id': {
                immediate: true,
                handler: function(tripId) {
                    if (!tripId) return;
                    http.get('/api/trips/' + tripId).then(response => {
                        if (!this.hotel.default_start_tz) this.$set(this.hotel, 'default_start_tz', response.data.trip_tz);
                        if (!this.hotel.default_end_tz) this.$set(this.hotel, 'default_end_tz', response.data.trip_tz);
                    });
                }
            }
        },
        components: {ContainerListItem, SubheaderListItem, CardList}
    };
</script>
